import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Service from '../../../util/Service';
import BpmnEditorPanel from '../BpmnEditorPanel';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function BpmnManagerDialog(props) {
   const {open, setOpen, bpm} = props;  
   const [bpmn, setBpmn] = React.useState();

   React.useEffect(() =>{
        if( open){
            Service.GET("/api/bpmn/buscaByNome/"+bpm).then(r=>{
                console.log( r );
                setBpmn(r);
            })
        }
   }, [open])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (    
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Sound
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Voltar
            </Button>
          </Toolbar>
        </AppBar>
        {bpmn && <BpmnEditorPanel rootProcesso={bpmn} stylePacote={{
              zIndex: 2,
              // width:'300px',
              position: 'absolute',
              // position: 'relative',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)'
              // display:'flex', justifyContent: 'center', alignItems:"flex-start"
          }}
          /> }
      </Dialog>
  );
}
